export const SetPageTitle = (title) => {
  try {
    const el = document.querySelector("#lblPageTitle");
    if (el) {
      el.innerHTML = title;
      sessionStorage.setItem("session_PageName", title);
    }
  } catch (error) {
    console.log(error);
  }
};
